import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { postSubmit } from "@ui-seeker/utils"
import { track } from "@analytics"


import { commonFiltersValue, encodeCommonFiltersShareValue, currentPeriod } from '@signals'


export default function useShareUrl() {
    const { pathname } = useLocation()

    const buildShareParams = (extraData = {}) => {
        const filters = {
            ...commonFiltersValue.peek(),
            currentPeriod: currentPeriod.value,
            ...extraData
        }

        if (filters?.sku?.length > 500)
            filters.sku = []

        return encodeCommonFiltersShareValue(filters)
    };

    const spParam = useMemo(() => buildShareParams(), [])

    const shortenURL = extraData => {
        // The shared link is the intent worth measuring; the filters behind it already ride on the
        // `data_query` row of the same session, and the url itself is excluded from that capture.
        track('share_url_created', { screen: pathname })
        return postSubmit("/generate-short-url", {
            url: `${pathname}?sp=${buildShareParams(extraData)}`
        })
    }

    return {
        spParam,
        buildShareParams,
        buildAbsoluteShareURL: (extradata = {}) => shortenURL(extradata),
    }
}